import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Sidebar from './components/layout/Sidebar';
import Home from './pages/Home/Home';
import HTML from './pages/HTML/HTML';
import CSS from './pages/CSS/CSS';
import JavaScript from './pages/JavaScript/JavaScript';
import Python from './pages/Python/Python';
import MySQL from './pages/MySQL/MySQL';
import Git from './pages/Git/Git';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <div className="main-container">
          <Sidebar />
          <div className="content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/html" element={<HTML />} />
              <Route path="/css" element={<CSS />} />
              <Route path="/javascript" element={<JavaScript />} />
              <Route path="/python" element={<Python />} />
              <Route path="/mysql" element={<MySQL />} />
              <Route path="/git" element={<Git />} />
            </Routes>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;
